<template>
<div>
  <el-row type="flex" :gutter="40">
    <el-col style="width:300px">
      <div class="vertical-center-box">
        <el-radio-group v-model="resultType" style="margin-bottom: 15px;">
          <el-radio-button label="TRIGGER">템플릿</el-radio-button>
          <el-radio-button label="JOB">작업</el-radio-button>
        </el-radio-group>
      </div>
    </el-col>
    <el-col style="width:calc(100% - 300px)">
      <div v-show="resultType === 'TRIGGER'" class="vertical-center-box" style="margin-top:-2px;display:block;">
        <el-tag v-show="triggerFilterList.length > 0" size="medium" @click="deleteFilter(null, 'TRIGGER')" class="mr-r4" style="cursor:pointer">
          초기화
        </el-tag>
        <el-tag v-for="(filter, index) in triggerFilterList" :key="index" closable :type="filter.tagType" size="medium" @close="deleteFilter(filter, 'TRIGGER')" class="mr-r4">
          {{filter.name}}
        </el-tag>
      </div>
      <div v-show="resultType === 'JOB'" class="vertical-center-box" style="margin-top:-2px;display:block;">
        <el-tag v-show="jobFilterList.length > 0" size="medium" @click="deleteFilter(null, 'JOB')" class="mr-r4" style="cursor:pointer">
          초기화
        </el-tag>
        <el-tag v-for="(filter, index) in jobFilterList" :key="index" closable :type="filter.tagType" size="medium" @close="deleteFilter(filter, 'JOB')" class="mr-r4">
          {{filter.name}}
        </el-tag>
      </div>
    </el-col>
  </el-row>
  <div v-show="resultType == 'TRIGGER'">
    <el-row type="flex" :gutter="40">
      <el-col style="width:300px">
        <w-result-status-pie-chart ref="triggerResultStatusPieChart" result-type="TRIGGER" :active="active" :filter-list="triggerFilterList" @set-result-filter="setResultFilter" style="height:200px"></w-result-status-pie-chart>
        <w-trigger-list ref="triggerTriggerList" result-type="TRIGGER" :active="active" :filter-list="triggerFilterList" @set-result-filter="setResultFilter"></w-trigger-list>
      </el-col>
      <el-col style="width:calc(100% - 300px)">
        <w-stacked-column-chart :filter-list="triggerFilterList" :search-params="triggerSearchParams" :active="active" style="height:150px"></w-stacked-column-chart>
        <w-trigger-result-table :filter-list="triggerFilterList" :active="active" @get-search-params="getSearchParams"></w-trigger-result-table>
      </el-col>
    </el-row>
  </div>
  <div v-show="resultType == 'JOB'">
    <el-row type="flex" :gutter="40">
      <el-col style="width:300px">
        <w-result-status-pie-chart ref="jobResultStatusPieChart" result-type="JOB" :active="active" :filter-list="jobFilterList" @set-result-filter="setResultFilter" style="height:200px"></w-result-status-pie-chart>
        <w-trigger-list ref="jobTriggerList" result-type="JOB" :active="active" :filter-list="jobFilterList" @set-result-filter="setResultFilter"></w-trigger-list>
      </el-col>
      <el-col style="width:calc(100% - 300px)">
        <w-job-result-table :filter-list="jobFilterList" :active="active"></w-job-result-table>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import { isEqual, isNil, isEmpty } from 'lodash';
import WTriggerList from './components/TriggerList';
import WResultStatusPieChart from './components/ResultStatusPieChart';
import WTriggerResultTable from './components/TriggerResultTable';
import WJobResultTable from './components/JobResultTable';
import WStackedColumnChart from './components/StackedColumnChart';

export default {
  name: 'WExecutionResult',
  components: {
    WTriggerList,
    WResultStatusPieChart,
    WTriggerResultTable,
    WJobResultTable,
    WStackedColumnChart,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    activeSubTab: {
      type: String,
      default: 'TRIGGER',
    },
    summaryFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resultType: 'TRIGGER',
      triggerFilterList: [],
      jobFilterList: [],
      selectedResultTrigger: null,
      triggerSearchParams: null,
    };
  },
  computed: {
    forceAmsTriggerResultLoad() {
      return this.$store.state.ams.forceAmsTriggerResultLoad;
    },
  },
  watch: {
    active: {
      handler() {
        this.resultType = this.activeSubTab;
      },
    },
    resultType: {
      handler(resultType) {
        this.$emit('change-sub-tab', resultType);
      },
    },
    summaryFilters: {
      handler(arr) {
        if (!isEmpty(arr)) {
          this.deleteFilter(null, this.resultType);
          arr.forEach((filter) => {
            this.setResultFilter(filter, this.activeSubTab);
          });
        }
      },
    },
    forceAmsTriggerResultLoad: {
      handler(value) {
        if (value) {
          this.$emit('force-result-load');
          this.$store.dispatch('setForceAmsTriggerResultLoad', false);
        }
      },
    },
  },
  methods: {
    getSearchParams(searchParams) {
      this.triggerSearchParams = searchParams;
    },
    setResultFilter(filter, resultType) {
      let filterList = this.triggerFilterList;
      if (isEqual(resultType, 'JOB')) {
        filterList = this.jobFilterList;
      }
      if (filter.selected) {
        filterList.push(filter);
      } else {
        let deleteFilter = null;
        if (isEqual(filter.type, 'resultStatus')) {
          deleteFilter = filterList.filter((item) => isEqual(item.label, filter.label))[0];
        } else {
          deleteFilter = filterList.filter((item) => isEqual(item.triggerId, filter.triggerId))[0];
        }
        filterList.splice(filterList.indexOf(deleteFilter), 1);
      }
      if (isEqual(resultType, 'TRIGGER')) {
        this.triggerFilterList = filterList;
      } else {
        this.jobFilterList = filterList;
      }
    },
    deleteFilter(filter, resultType) {
      let filterList = this.triggerFilterList;
      if (isEqual(resultType, 'JOB')) {
        filterList = this.jobFilterList;
      }
      if (!isNil(filter)) {
        let deletedFilter = filter;
        if (isEqual(filter.type, 'resultStatus')) {
          deletedFilter = filterList.filter((item) => isEqual(item.label, filter.label))[0];
          filterList.splice(filterList.indexOf(deletedFilter), 1);
          if (isEqual(resultType, 'TRIGGER')) {
            this.$refs.triggerResultStatusPieChart.deleteResultFilter(filter);
          } else {
            this.$refs.jobResultStatusPieChart.deleteResultFilter(filter);
          }
        } else {
          filterList.splice(filterList.indexOf(deletedFilter), 1);
          if (isEqual(resultType, 'TRIGGER')) {
            this.$refs.triggerTriggerList.deleteResultFilter(filter);
          } else {
            this.$refs.jobTriggerList.deleteResultFilter(filter);
          }
        }
      } else if (isNil(filter)) {
        if (isEqual(resultType, 'TRIGGER')) {
          this.triggerFilterList = [];
          this.$refs.triggerResultStatusPieChart.deleteResultFilter();
          this.$refs.triggerTriggerList.deleteResultFilter();
        } else {
          this.jobFilterList = [];
          this.$refs.jobResultStatusPieChart.deleteResultFilter();
          this.$refs.jobTriggerList.deleteResultFilter();
        }
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecutionResult/index.vue